const TYPES = [
  'COR:user', //1
  'COR:product', //2
  'COR:driver', //3
  'COR:vehicle', //4
  'COR:vehicletype', //5
  'COR:group', //6
  'COR:client', //7
  'COR:country', //8
  'COR:vehicle:create', //9
  'COR:vehicle:update', //10
  'COR:vehicle:delete', //11
  'COR:client:create', //12
  'COR:client:update', //13
  'COR:client:delete', //14
  'COR:client:disable', //15
  'COR:client:plate', //16
  'COR:provider:create', //17
  'COR:provider:edit', //18
  'COR:provider:delete', //19
  'COR:provider', //20
  'COR:business:create', //21
  'COR:business:edit', //22
  'COR:business:delete', //23
  'COR:business', //24
  'COR:spot:create', //25
  'COR:spot:edit', //26
  'COR:spot:delete', //27
  'COR:spot', //28
  'COR:item:create', //29
  'COR:item:edit', //30
  'COR:item:delete', //31
  'COR:item', //32
  'COR:group:createchild', //33
  'COR:itemData:create', //34
  'COR:itemData:edit', //35
  'COR:itemData:delete', //36
  'COR:itemData', //37
  'COR:enum', //38

  'COR:user:nav', //39
  'COR:product:nav', //40
  'COR:driver:nav', //41
  'COR:vehicle:nav', //42
  'COR:vehicletype:nav', //43
  'COR:group:nav', //44
  'COR:client:nav', //45
  'COR:country:nav', //46
  'COR:provider:nav', //47
  'COR:business:nav', //48
  'COR:spot:nav', //49
  'COR:item:nav', //50
  'COR:itemData:nav', //51
  'COR:salesagent', //52
  'COR:salesagent:nav', //53
  'COR:Questionnaire:Activate', //54
  'COR:Questionnaire:create', //55
  'COR:Questionnaire:delete', //56
  'COR:Questionnaire:DriverApp', //57
  'COR:Questionnaire:edit', //58
  'COR:Questionnaire:nav', //59
];

const canUserAccess = (client, permType, store) => {
  const permissions = store.getters.permissionUser;
  const permsByClient = permissions[client];
  if (!permsByClient) {
    return false;
  }
  return permsByClient.includes(TYPES[Number(permType) - 1]);
};

const hasPermission = (permission, store) => {
  let rawpermissions = store.getters.permissionUser;
  let permissions = [];
  if (typeof rawpermissions === 'object') {
    Object.keys(rawpermissions).forEach((k) => {
      let rawArray = rawpermissions[k];
      if (Array.isArray(rawArray)) {
        permissions = [...permissions, ...rawArray];
      }
    });
  }
  console.log(permissions);
  return permissions.includes(permission) || permissions.includes('COR:*');
};

module.exports = { canUserAccess, hasPermission };
